import { useTranslation } from 'react-i18next';

import { EMPTY_FIELD } from 'support/helpers/const/const';

type OrderSummaryCardItemProps = {
  label: string;
  value?: string;
};

type OrderSummaryCardProps = {
  orderNumber?: string;
  orderDate?: string;
};

export const OrderSummaryCard = ({ orderNumber, orderDate }: OrderSummaryCardProps) => {
  const { t } = useTranslation();
  return (
    <div className="min-w-80 rounded-2xl bg-gray-50 px-6 py-4">
      <OrderSummaryCardItem label={t('orderForms:success.orderNumber')} value={orderNumber} />
      <OrderSummaryCardItem label={t('orderForms:success.orderDate')} value={orderDate} />
    </div>
  );
};

const OrderSummaryCardItem = ({ label, value }: OrderSummaryCardItemProps) => (
  <div className="flex items-center justify-between gap-4 text-sm leading-5">
    <span className="shrink-0 text-gray-500">{label}</span>
    <span className="shrink-0 text-right text-gray-900">{value ?? EMPTY_FIELD}</span>
  </div>
);
